export const questionsAndAnswers = [
  {
    question: "Why should I upgrade to Pro?",
    answer:
      "With the Pro version, our amazing cut-sheet app transforms into a comprehensive order management system. You gain the ability to effortlessly create, manage, and edit an unlimited number of sites with unlimited runs. Our product is truly unique in the industry and there is nothing else like it out there.",
  },
  {
    question: "If I downgrade from Pro, do I lose all my site data?",
    answer:
      "Rest assured, upgrading to the free version won't cause you to lose any of your data. Although you may temporarily lose access to it, once you upgrade to the Pro version again, your data will still be there and readily accessible.",
  },
  {
    question: "Can I Pay Yearly?",
    answer:
      "Absolutely! By opting to pay for a yearly subscription, you can enjoy a 15% discount off the monthly price.",
  },
  {
    question:
      "Can I get unlimited use license for all of my company employees?",
    answer:
      "Definitely! To learn more about obtaining an EasyDuct site license, please contact our licensing specialists at 425-270-8466. They will be more than happy to provide you with all the necessary details.",
  },
];
